const getLevelFromPriceCategory = (category?: string) => {
  if (!category) {
    return null;
  }

  const [_, level] = category.split("-");

  return parseInt(level, 10);
};

export { getLevelFromPriceCategory };
